import { put, takeLatest } from "redux-saga/effects";
import { REQUEST_PRODUCT, RECEIVE_PRODUCT } from "./actions";
import http from "api";
import { history } from "store";

export function* requestProductAsync(action) {
  const { payload } = action;

  try {
    const response = yield http.get(`/doors/${payload}`);

    const newState = response.data;

    yield put({
      type: RECEIVE_PRODUCT,
      payload: newState
    });
  } catch (error) {
    const { status } = error.response;
    if (status === 404) history.push("/products");
  }
}

export default function* productDetailsRootSaga() {
  yield takeLatest(REQUEST_PRODUCT, requestProductAsync);
}
